import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import { type SvgIconComponent } from '@mui/icons-material';

import { IUploadInformation } from '../models/interfaces/IUploadInformation';
import { UploadType } from '../models/enums/UploadType';

export type UploadTypeMeta = {
    label: string;
    description: string;
    Icon: SvgIconComponent;
};

export const UPLOAD_TYPE_META: Record<UploadType, UploadTypeMeta> = {
    [UploadType.S3]: {
        label: 'SFTP',
        description: 'Browse SFTP files',
        Icon: CloudOutlinedIcon,
    },
    [UploadType.LocalUpload]: {
        label: 'Local Upload',
        description: 'Upload files from your computer',
        Icon: ComputerOutlinedIcon,
    },
    [UploadType.ServerFileUpload]: {
        label: 'Server File',
        description: 'Pick files from the server',
        Icon: StorageOutlinedIcon,
    },
};

export function resolveAvailableUploadTypes(info: IUploadInformation): UploadType[] {
    const types: UploadType[] = [];
    if (info.IsLocalUploadEnabled || info.IsLocalUploadToS3Enabled) {
        types.push(UploadType.LocalUpload);
    }
    if (info.IsServerPathUploadEnabled) {
        types.push(UploadType.ServerFileUpload);
    }
    if (info.IsS3UploadEnabled) {
        types.push(UploadType.S3);
    }
    return types;
}
